import script from "./Material.vue?vue&type=script&setup=true&lang=js"
export * from "./Material.vue?vue&type=script&setup=true&lang=js"

import "./Material.vue?vue&type=style&index=0&id=b3e8c7cc&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e8c7cc"]])

export default __exports__